import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalConfirmacion from '../Components/ModalComfirmacion/ModalConfirmacion';

import { sendUserData } from '../Services/Form';
import { ContainerButtonPlay } from '../Utils/Button';
import { IUserFromStorage } from '../Interfaces/IUser';
import { IInitialState } from '../Shared/data/FormReducer';
import { portadaPostTest } from '../Shared/Images/producto2';
import { actualizarVideoVisto } from '../Services/DespuesTest';


import { grayPlayButton } from '../Shared/Images';
import iconInicio from '../Shared/Images/bienvenido-icon.png';


function DespuesTest() {
  const state: IInitialState = JSON.parse(localStorage.getItem('state'));
  const navigate = useNavigate();

  const [terminoVerVideo, setTerminoVerVideo] = useState<boolean>(false);
  const [isOpenModalConfirmacion, setisOpenModalConfirmacion] = useState<boolean>(false)
  const [user, setUser] = useState<IUserFromStorage>(
    JSON.parse(localStorage.getItem('user')),
  );
  const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (user.respondio && user.videoVisto) {
      navigate('/');
    }
  }, [user]);

  const handleTerminarVideo = () => {
    actualizarVideoVisto({
      UsuarioTestAsesoriaID: Number(user.usuarioTestAsesoriaID),
    }).then(() => {
      setTerminoVerVideo(true);
      navigate('/');
    });
  };

  const handleIrAInicio = () => {
    setisOpenModalConfirmacion(true);
  };

  useEffect(() => {
    setLoading(true);
    sendUserData({
      Correo: user.correo,
      Clave: user.clave,
    })
      .then((response) => {
        const updatedUser = { ...user, ...response.data.data };
        setUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
      })
      .finally(() => setLoading(false));
  }, [terminoVerVideo]);

  useEffect(() => {
    (function (
      v: any,
      i: Document,
      d: string,
      a: string,
      l: string
    ) {
      const y = `_${d.toLowerCase()}`;
      const c = `${d}L`;

      if (!v[d]) v[d] = {};
      if (!v[c]) v[c] = {};
      if (!v[y]) v[y] = {};

      const vl = 'Loader';
      let vli = v[y][vl];
      let vsl = v[c][vl + 'Script'];
      let vlf = v[c][vl + 'Loaded'];
      const ve = 'Embed';

      if (!vsl) {
        vsl = function (u: string, cb: () => void) {
          if (vlf) {
            cb();
            return;
          }

          const s = i.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = u;

          if ((s as any).readyState) {
            (s as any).onreadystatechange = function () {
              if (
                (s as any).readyState === 'loaded' ||
                (s as any).readyState === 'complete'
              ) {
                (s as any).onreadystatechange = null;
                vlf = 1;
                cb();
              }
            };
          } else {
            s.onload = function () {
              vlf = 1;
              cb();
            };
          }

          i.getElementsByTagName('head')[0].appendChild(s);
        };
        v[c][vl + 'Script'] = vsl;
      }

      vsl(l + 'loader.min.js', function () {
        if (!vli) {
          const vlc = v[c][vl];
          vli = new vlc();
        }

        vli.loadScript(l + 'player.min.js', function () {
          const vec = v[d][ve];
          const t = new vec();
          t.run(a);
        });
      });
    })(
      window,
      document,
      'Vidalytics',
      'vidalytics_embed_JyyZPbDmk5ySJhoY',
      'https://fast.vidalytics.com/embeds/IoH8SL8U/JyyZPbDmk5ySJhoY/'
    );
  }, []);

  return (
    <div className="min-h-[80dvh] md:flex md:flex-col md:items-center md:justify-center">
    <div className="h-[3vh] w-full"></div>
      {!loading ? (
        user.objetivo !== null && (
          <div className="flex flex-col items-start  w-full md:w-[60%] m-auto p-2 md:min-w-[600px] min-h-[70dvh]">
            <div
              className="flex items-center md:hidden"
              style={{ gap: '1rem', marginBottom: '2.5rem' }}
            >
              <img src={iconInicio} alt="img-icon" style={{ width: '25px' }} />
              <p
                style={{ margin: 0, fontWeight: 'bold', fontSize: '1.5rem' }}
                className="title"
              >
                {state && state.sexo
                  ? `Bienvenido ${user.nombres}`
                  : `Bienvenida ${user.nombres}`}
              </p>
            </div>
            <div className=" w-full flex items-center justify-center">
              <div className="w-full my-4">
                {!mostrarVideo ? (
                  <div
                    style={{
                      position: 'relative',
                    }}
                    className="relative"
                  >
                    <ContainerButtonPlay
                      onClick={() => {
                        setMostrarVideo(true);
                      }}
                    >
                      <img
                        src={grayPlayButton}
                        alt=""
                        width={80}
                        style={{ cursor: 'pointer' }}
                      />
                    </ContainerButtonPlay>

                    <img
                      width={'100%'}
                      height={'100%'}
                      src={portadaPostTest}
                      alt="portada"
                    />
                  </div>
                ) : (
                  <>
                    {loading ? (
                      <VideoSkeleton />
                    ) : (
                      // <ReactPlayer
                      //   playing={true}
                      //   width={'100%'}
                      //   height={'100%'}
                      //   controls={true}
                      //   url={
                      //     'https://player.vimeo.com/external/908706198.m3u8?s=c37acc77ac24d7503e6cffe6def780bc338eb8f5'
                      //   }
                      //   config={{
                      //     youtube: {
                      //       playerVars: {
                      //         modestbranding: 1,
                      //         iv_load_policy: 3,
                      //       },
                      //     },
                      //   }}
                      //   onEnded={handleTerminarVideo}
                      // />

                      <div
                        id="vidalytics_embed_JyyZPbDmk5ySJhoY"
                        style={{
                          width: '100%',
                          position: 'relative',
                          paddingTop: '56.25%',
                        }}
                      ></div>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="flex flex-col items-center justify-center w-full">
              <p className="text-justify">
                Es importante que veas el video completamente para que entiendas como
                funciona la plataforma.
              </p>
              <button
                className="font-bold bg-yellowTr4iner px-14 py-2 rounded-xl"
                onClick={handleIrAInicio}
              >
                Vamos
              </button>
            </div>
          </div>
        )
      ) : (
        <div className="h-[50dvh] flex items-center justify-center">
          <VideoSkeleton />
        </div>
      )}

      <ModalConfirmacion 
        isOpen={isOpenModalConfirmacion}
        setIsOpen={setisOpenModalConfirmacion}
        terminarVideo={handleTerminarVideo}
      />


    </div>
  );
}

export default DespuesTest;

const VideoSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse w-[80dvh] h-[50dvh] pb-[46.25%] relative bg-gray-300 max-w-[80vw]" >
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
        <div className="w-16 h-16 bg-gray-400 rounded-full"></div>
      </div>
    </div>
  );
};
